import { render } from "./VehicleCreate.vue?vue&type=template&id=0872aad4"
import script from "./VehicleCreate.vue?vue&type=script&lang=js"
export * from "./VehicleCreate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/furkanyesil/Projects/fair-mieten-mg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__